import React, { useEffect } from 'react';
import type { ProductModalProps } from '../types';

const ProductModal: React.FC<ProductModalProps> = ({ product, onClose, onQuote }) => {
  useEffect(() => {
    const h = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', h);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', h); document.body.style.overflow = ''; };
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div style={{ position: 'relative' }}>
          <img src={product.img} alt={product.title} style={{ width: '100%', aspectRatio: '16/9', objectFit: 'cover' }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(26,43,74,0.5), transparent)' }} />
          <span style={{ position: 'absolute', top: 14, right: 14, background: '#f5c518', color: '#1a2b4a', fontSize: 9, fontWeight: 800, letterSpacing: '0.16em', textTransform: 'uppercase', padding: '4px 12px', borderRadius: 100 }}>
            {product.tag}
          </span>
        </div>
        <div style={{ padding: 32 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
            <div>
              <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 30, color: '#1a2b4a', marginBottom: 6 }}>{product.title}</h2>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#f5c518', letterSpacing: '0.12em', textTransform: 'uppercase' }}>{product.subtitle}</div>
            </div>
            <button onClick={onClose} style={{ background: 'none', border: '1px solid #e2e8f0', width: 36, height: 36, borderRadius: 4, cursor: 'pointer', fontSize: 16, color: '#718096', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginLeft: 16 }}>
              ✕
            </button>
          </div>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#718096', marginBottom: 24, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
            {product.desc}
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button className="btn-yellow" style={{ flexGrow: 1 }} onClick={onQuote}>Request a Quote</button>
            <button onClick={onClose} style={{ background: 'none', border: '1px solid #e2e8f0', padding: '12px 20px', cursor: 'pointer', fontSize: 13, color: '#718096', borderRadius: 3 }}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProductModal;
